import { render } from "./ChatbotInterface.vue?vue&type=template&id=2cfce0ad&scoped=true&ts=true"
import script from "./ChatbotInterface.vue?vue&type=script&lang=ts"
export * from "./ChatbotInterface.vue?vue&type=script&lang=ts"

import "./ChatbotInterface.vue?vue&type=style&index=0&id=2cfce0ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfce0ad"]])

export default __exports__